export const FETCH_GLOBALSEARCH_BEGIN = "FETCH_GLOBALSEARCH_BEGIN";
export const FETCH_GLOBALSEARCH_SUCCESS = "FETCH_GLOBALSEARCH_SUCCESS";
export const FETCH_GLOBALSEARCH_FAILURE = "FETCH_GLOBALSEARCH_FAILURE";

